export default __webpack_public_path__ + "static/media/ipbloc.f624003a.jpg";